import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';

export const ExternalShareWarningIconGroup: React.FC<SvgProps> = (props) => {
  const gradientId = `${props.groupIdPrefix ?? 'external-share-warning-icon'}-gradient`;

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M16 29.3327C23.3638 29.3327 29.3334 23.3631 29.3334 15.9993C29.3334 8.63555 23.3638 2.66602 16 2.66602C8.63622 2.66602 2.66669 8.63555 2.66669 15.9993C2.66669 23.3631 8.63622 29.3327 16 29.3327Z"
        fill="#D41515"
      />
      <path
        d="M16 29.3327C23.3638 29.3327 29.3334 23.3631 29.3334 15.9993C29.3334 8.63555 23.3638 2.66602 16 2.66602C8.63622 2.66602 2.66669 8.63555 2.66669 15.9993C2.66669 23.3631 8.63622 29.3327 16 29.3327Z"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M16 10.666V15.9993"
        stroke="#14181C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 21.334H16.0133"
        stroke="#14181C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="8.4661"
          y1="8.47063"
          x2="28.6413"
          y2="29.0272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.88" />
          <stop offset="1" stopColor="#3A3AE8" />
        </linearGradient>
      </defs>
    </g>
  );
};

export const ExternalShareWarningIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...(props.svg ?? {})}
    >
      <ExternalShareWarningIconGroup {...props} />
    </svg>
  );
};
